let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("aYGIV"), load("2YtxS"), load("hUMW4"), load("7qp3S"), load("KsAVd"), load("1C6qR")]).then(() => parcelRequire('kTkGJ'));